import { useState, useCallback, useEffect } from 'react'
import { loadFiltersForPage, persistFiltersForPage } from './klienciFiltersStorage'

export default function useKlienciListFilters(pageKey) {
	const [filters, setFilters] = useState(() => loadFiltersForPage(pageKey))

	const updateFilters = useCallback(newFilters => {
		setFilters(prevFilters => ({ ...prevFilters, ...newFilters }))
	}, [])

	useEffect(() => {
		persistFiltersForPage(pageKey, filters)
	}, [pageKey, filters])

	return {
		filters,
		updateFilters,
		searchQuery: filters.searchText || '',
	}
}
